import { useStarterDashboardPageFcmExperiments } from 'src/app/pages/starterDashboard/pageContext';

type UseGroupRecsNewDesignExperiment = ModelHookResult<{
	variant: string;
	isVariant: boolean;
}>;

export function useGroupRecsNewDesignExperiment(): UseGroupRecsNewDesignExperiment {
	const {
		groupRecsNewDesignExperiment: { variation },
	} = useStarterDashboardPageFcmExperiments();

	return {
		data: {
			variant: variation,
			isVariant: variation !== 'control',
		},
	};
}
